import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, vShow as _vShow, withDirectives as _withDirectives, createBlock as _createBlock, createTextVNode as _createTextVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "flex flex-col w-full mt-12 mb-12 text-center select-none"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("p", {
  style: {"font-size":"10rem"},
  class: "material-icons-outlined opacity-10"
}, " search_off ", -1)
const _hoisted_3 = { class: "opacity-40" }
const _hoisted_4 = { key: 1 }
const _hoisted_5 = {
  key: 1,
  class: "w-full mt-4 h-4 mb-2 skeleton-unit"
}
const _hoisted_6 = { key: 2 }
const _hoisted_7 = { key: 2 }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("div", { class: "w-full h-1 bg-gray-200 rounded-md" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ExerciseSearchFilters = _resolveComponent("ExerciseSearchFilters")!
  const _component_FullExercise = _resolveComponent("FullExercise")!
  const _component_ExerciseSolutionContainer = _resolveComponent("ExerciseSolutionContainer")!
  const _component_Btn = _resolveComponent("Btn")!
  const _component_SlotSkeleton = _resolveComponent("SlotSkeleton")!
  const _component_Spinner = _resolveComponent("Spinner")!
  const _component_VueEternalLoading = _resolveComponent("VueEternalLoading")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_ExerciseSearchFilters, {
      class: "bg-transparent mb-10 rounded-sm",
      allowFilterByState: false,
      allowFilterByType: false,
      full: false,
      modelValue: _ctx.searchFilter,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.searchFilter) = $event)),
      onResetFilters: _cache[1] || (_cache[1] = ($event: any) => (_ctx.searchFilter = _ctx.getBlankExerciseSearchFilters()))
    }, null, 8, ["modelValue"]),
    (!_ctx.firstLoading && !_ctx.loading && _ctx.mainStore.exercises.length === 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _hoisted_2,
          _createElementVNode("h2", _hoisted_3, _toDisplayString(_ctx.$t("course_exercises.no_matching_exercises")), 1)
        ]))
      : _createCommentVNode("", true),
    (!_ctx.firstLoading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.mainStore.exercises, (exercise) => {
            return (_openBlock(), _createElementBlock("div", {
              class: "mb-14",
              key: 'e-' + exercise.id
            }, [
              _createVNode(_component_FullExercise, { exercise: exercise }, null, 8, ["exercise"]),
              (!_ctx.loadingSolutionsByExercise[exercise.id])
                ? _withDirectives((_openBlock(), _createBlock(_component_ExerciseSolutionContainer, {
                    key: 0,
                    class: "mt-4",
                    exercise: exercise,
                    solutions: _ctx.mainStore.getPaginatedSolutionsByExerciseId(exercise.id).data,
                    canLoadMore: 
						!_ctx.mainStore.getPaginatedSolutionsByExerciseId(exercise.id).isLastPage
					,
                    onLoadMore: ($event: any) => (_ctx.loadMore(exercise))
                  }, null, 8, ["exercise", "solutions", "canLoadMore", "onLoadMore"])), [
                    [_vShow, 
						_ctx.showSolutionsByExercise[exercise.id] ||
						_ctx.getSolutionCountForExercise(exercise) === 0
					]
                  ])
                : (_openBlock(), _createElementBlock("div", _hoisted_5)),
              (
						!_ctx.loadingSolutionsByExercise[exercise.id] &&
						!_ctx.showSolutionsByExercise[exercise.id] &&
						_ctx.getSolutionCountForExercise(exercise) > 0
					)
                ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                    _createVNode(_component_Btn, {
                      onClick: ($event: any) => (_ctx.showSolutionsByExercise[exercise.id] = true),
                      size: 'sm',
                      class: "mt-2 -ml-4",
                      variant: 'primary-borderless'
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.$t("exercise_solution.reveal_solutions_1")) + " " + _toDisplayString(_ctx.getSolutionCountForExercise(exercise)) + " " + _toDisplayString(_ctx.getSolutionCountForExercise(exercise) === 1
								? _ctx.$t("exercise_solution.reveal_solutions_2_singular")
								: _ctx.$t("exercise_solution.reveal_solutions_2_plural")), 1)
                      ]),
                      _: 2
                    }, 1032, ["onClick"])
                  ]))
                : _createCommentVNode("", true)
            ]))
          }), 128))
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_7, [
          _createVNode(_component_SlotSkeleton),
          _createVNode(_component_SlotSkeleton),
          _createVNode(_component_SlotSkeleton),
          _createVNode(_component_SlotSkeleton)
        ])),
    (!_ctx.firstLoading)
      ? (_openBlock(), _createBlock(_component_VueEternalLoading, {
          key: 3,
          load: _ctx.onLoadMore,
          "is-initial": _ctx.isInitialInfiniteLoad,
          "onUpdate:is-initial": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.isInitialInfiniteLoad) = $event))
        }, {
          loading: _withCtx(() => [
            _createVNode(_component_Spinner)
          ]),
          "no-more": _withCtx(() => [
            _hoisted_8
          ]),
          _: 1
        }, 8, ["load", "is-initial"]))
      : _createCommentVNode("", true)
  ]))
}